// src/i18n/es.ts
export const es = {
  landing: {
    verifying: 'Verificando invitación...',
    invalidTitle: 'Invitación no válida',
    validTitle: 'Invitación válida',
    typeFace: 'Enrolamiento Facial',
    typeAccount: 'Creación de Cuenta',
    expires: 'Expira:',
    start: 'Comenzar',
  },
  identity: {
    step: 'Paso 1 de 2',
    title: 'Verificación de identidad',
    subtitle: 'Ingresá los datos exactos de tu documento.',
    country: 'País',
    countryPlaceholder: 'Seleccionar...',
    idType: 'Tipo de documento',
    idTypePlaceholder: 'Seleccionar...',
    number: 'Número',
    numberPlaceholder: 'Ej: 12345678',
    verify: 'Verificar identidad',
    verifying: 'Verificando...',
  },
  enroll: {
    title: 'Enrolamiento facial',
    completed: 'completadas',
    of: 'de',
    completionTitle: '¡Enrolamiento completo!',
    completionMessage: '¿Querés terminar el enrolamiento o modificar alguna imagen?',
    finish: 'Terminar',
    modify: 'Modificar',
    positionStart: 'Comenzar',
    infoTitle: 'Prepará tu entorno',
    infoSubtitle: 'Para obtener las mejores fotos, seguí estas recomendaciones:',
    infoStand: 'Parate frente a la cámara a una distancia de 30-50 cm.',
    infoBackground: 'Buscá un fondo blanco o de color neutro.',
    infoLook: 'Mirá fijamente a la cámara sin lentes de sol ni gorra.',
    infoLight: 'Asegurate de tener buena iluminación frontal.',
    infoStart: 'Comenzar enrolamiento',
    positions: {
      FRONT: { name: 'Frente', hint: 'Mirá directo a la cámara', instruction: 'Mirá directo a la cámara con la cabeza quieta' },
      UP: { name: 'Arriba', hint: 'Mové ligeramente la cabeza hacia arriba', instruction: 'Mové ligeramente la cabeza hacia arriba' },
      DOWN: { name: 'Abajo', hint: 'Mové ligeramente la cabeza hacia abajo', instruction: 'Mové ligeramente la cabeza hacia abajo' },
      LEFT: { name: 'Izquierda', hint: 'Girá un poco la cabeza a tu izquierda', instruction: 'Girá un poco la cabeza a tu izquierda' },
      RIGHT: { name: 'Derecha', hint: 'Girá un poco la cabeza a tu derecha', instruction: 'Girá un poco la cabeza a tu derecha' },
    },
  },
  camera: {
    noFace: 'Acercá tu rostro a la cámara',
    notCentered: 'Centrá tu rostro en el marco',
    wrongPose: 'Ajustá la posición de tu cabeza',
    blink: 'Parpadeá una vez',
    holdPose: 'Mantené la pose...',
    perfect: '¡Perfecto! Capturando...',
    usePhoto: '¿Usar esta foto?',
    retake: 'Volver a tomar',
    confirm: 'Subir foto',
    uploading: 'Subiendo foto...',
    retryUpload: 'Reintentar envío',
    cameraError: 'Problema con la cámara',
    retry: 'Reintentar',
  },
  liveness: {
    face: 'Rostro detectado',
    centered: 'Centrado',
    pose: 'Posición correcta',
    blink: 'Parpadeo',
    hold: 'Mantén pose',
  },
  account: {
    step: 'Paso 2 de 2',
    title: 'Creá tu contraseña',
    subtitle: 'Definí la contraseña de tu cuenta. Después vas a poder ingresar con tu documento o tu email.',
    password: 'Contraseña',
    passwordPlaceholder: 'Mínimo 8 caracteres',
    confirm: 'Confirmar contraseña',
    confirmPlaceholder: 'Repetí tu contraseña',
    email: 'Email (opcional)',
    emailPlaceholder: 'tu@email.com',
    emailHint: 'Te va a servir para ingresar y recibir notificaciones.',
    mismatch: 'Las contraseñas no coinciden',
    tooShort: 'La contraseña debe tener al menos 4 caracteres',
    invalidEmail: 'El formato del email no es válido',
    submit: 'Activar cuenta',
    submitting: 'Activando...',
  },
  summary: {
    title: '¡Enrolamiento completado!',
    subtitle: 'Tu rostro fue registrado correctamente.',
    titleAccount: '¡Cuenta activada!',
    subtitleAccount: 'Tu contraseña fue registrada. Ya podés ingresar a la plataforma.',
    finish: 'Finalizar',
  },
  errors: {
    invalidInvitation: 'Invitación no válida',
    verifyIdentity: 'Error al verificar identidad',
    activateAccount: 'Error al activar la cuenta',
    missingContext: 'Falta contexto de enrolamiento, recargue la página.',
  },
} as const